import "./printSalesReciept.css";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { QRCodeCanvas } from "qrcode.react";
import Barcode from "react-barcode";
import CloseIcon from "@mui/icons-material/Close";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";

export default function PrintSalesReciept({ contentRef, salesPayload }) {
  const companyData = useSelector(
    (state) => state.clientFunction?.companiesDB?.clientData,
  );

  const { inventory } = useSelector(
    (state) => state.terminalActions?.registerData,
  );

  const { userData } = useSelector(
    (state) => state.clientFunction?.companiesDB,
  );

  const accessType = useSelector((state) => state.clientFunction?.accessType);

  const {
    salesId,
    customerId,
    cart,
    discount,
    customerName,
    setLoading,
    setOpenModal,
    secondaryFunction,
    setAlert,
    subTotal,
    tax,
    paymentMethods,
    createdAt,
  } = salesPayload;

  const discountAmount = salesPayload.discountAmount ?? (discount?.type === "PERCENTAGE"
    ? Number(subTotal) * Number(discount?.amount || 0) / 100
    : Number(discount?.amount ?? discount ?? 0) || 0);
  const receiptTotal = salesPayload.total ?? Math.round((Number(subTotal) - discountAmount + Number(tax || 0) + Number.EPSILON) * 100) / 100;

  const reactToPrintFn = useReactToPrint({ contentRef });
  return (
    <div
      className="SalesRecieptWrap fx-cl space2"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="printAreaRecieptWrap">
        <div className="receiptTicket fx-cl " ref={contentRef}>
          <div className="rectContTop fx-cl ">
            <div
              className="componentCont fw200 fx-ac fx-jb"
              style={{ fontSize: "1rem" }}
            >
              <div className="fx-ac">
                <span className="fw400">{createdAt}</span>
              </div>
              <div className="fx-ac">
                <span className="cb">Receipt No: </span>
                <span className="fw600">{salesId}</span>
              </div>
            </div>
            {/* TOP */}
            <div className="fx-cl">
              <h2>Sales Reciept</h2>
            </div>
            <div className="fx-ac fx-jc">
              <div
                className="componentCont fx-cl fx-ac fx-jc"
                style={{ textAlign: "center", width: "90%" }}
              >
                <span className="recptHead fw600 fs1">
                  {companyData?.businessProfile?.basicInfo?.businessName}
                </span>
                <span className="cb">
                  {inventory?.address
                    ? [
                        inventory.address.street,
                        inventory.address.area,
                        inventory.address.city,
                        inventory.address.state,
                        inventory.address.country,
                      ]
                        .filter(Boolean) // Removes empty string values
                        .join(", ")
                    : ""}
                </span>
                <span>
                  {companyData?.businessProfile?.location?.headOffice?.address}
                </span>
                {companyData?.businessProfile?.branding?.website && (
                  <span>{companyData?.businessProfile?.branding?.website}</span>
                )}
                <span className="cb fw600">
                  {companyData?.businessProfile?.basicInfo?.businessPhoneNo?.join(
                    " - ",
                  )}
                </span>
              </div>
            </div>
            <div
              className="componentCont fx-cl space2"
              style={{ borderTop: "1px dashed #333", paddingTop: ".8rem" }}
            >
              <div className="g g2 spacem">
                {/* BLUE BAR */}
                <div
                  className="ticketBlue fx-cl spacem"
                  style={{ borderRight: "1px dashed #333" }}
                >
                  <div className="fx-cl">
                    <span className=" cb">Processed by</span>
                    <strong>
                      {(accessType === "CLIENT_ACCESS"
                        ? companyData?.founder?.firstName
                        : userData?.personalInfo?.firstName) || "Guest"}
                    </strong>
                  </div>
                  <div className="fx-cl">
                    <span className=" cb">Sold Item:</span>
                    <strong>{cart?.length}</strong>
                  </div>
                </div>

                {/* RECEIPT DETAILS */}
                <div className="fx-cl spacem">
                  <div className="fx-cl">
                    <span className="cb ">Customer</span>
                    <strong>{customerName}</strong>
                  </div>

                  <div className="fx-cl">
                    <span className="cb ">Customer ID</span>
                    <strong>{customerId}</strong>
                  </div>
                </div>
              </div>
            </div>

            {/* ITEMS */}
            <div className="fx-cl spacem">
              {cart && cart.length > 0 ? (
                <table className="componentCont fx-cl">
                  <thead className="fx-cl spacem">
                    <tr>
                      <th>Item</th>
                      <th>Qty</th>
                      <th>Price</th>
                      <th>Ext Price</th>
                    </tr>
                  </thead>
                  <tbody className="fx-cl spacem">
                    {cart.map((item, index) => (
                      <tr key={item.sku || index} className="itemRowTdCont">
                        <td>
                          <strong>{item.name}</strong>
                        </td>
                        <td>{item.soldQuantity}</td>
                        <td>₦{item.pricing?.sellingPrice?.toLocaleString()}</td>
                        <td>
                          ₦
                          {(
                            item.soldQuantity * item.pricing?.sellingPrice
                          ).toLocaleString()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p style={{ textAlign: "center" }}>Empty</p>
              )}
            </div>
            <div className="recptTotal componentCont fx-jb">
              <span>
                {companyData && (
                  <QRCodeCanvas
                    value={JSON.stringify({
                      salesId: salesId || "",
                      customerName: customerName || "",
                      createdAt: createdAt || "",
                      companyName:
                        companyData?.businessProfile?.basicInfo?.businessName ||
                        "",
                      company_tel:
                        companyData?.businessProfile?.basicInfo?.business_tel ||
                        "",
                    })}
                    size={60}
                    // style={{ margin: "1rem" }}
                  />
                )}
              </span>
              <div className="fx-cl spacem">
                <div className="fx-jb space2">
                  <span>Subtotal: </span>
                  <strong>₦{subTotal}</strong>
                </div>
                <div className="fx-jb">
                  <span>Discount</span>
                  <strong>₦{Number(discountAmount).toLocaleString()}</strong>
                </div>

                <div className="fx-jb">
                  <span>Tax:</span>
                  <strong>₦{Number(tax || 0).toLocaleString()}</strong>
                </div>

                <div className="ticketTotal fx-jb spacem">
                  <span>
                    <strong>RECEIPT TOTAL:</strong>
                  </span>
                  <strong>
                    ₦
                    {Number(receiptTotal).toLocaleString()}
                  </strong>
                </div>
                <strong>Method: {paymentMethods}</strong>
              </div>
            </div>
          </div>
          <div className="rectContBottom fx-cl fx-ac">
            <div className="componentCont fx-cl fx-ac fx-jc">
              <span>THANK YOU FOR YOUR PATRONAGE!</span>
              <span>OPENING HOURS</span>
              <span>We are open 7 days a week.</span>
              <span>7:00 AM – 11:00 PM</span>
              <span>We look forward to serving you again.</span>
            </div>

            <Barcode
              value={salesId}
              format="CODE128"
              width={1.5}
              height={25}
              fontSize={12}
              displayValue={false}
            />
          </div>
          <span
            style={{
              textAlign: "center",
              fontFamily: "serif",
              fontStyle: "italic",
            }}
          >
            www.universeinventory.com
          </span>
        </div>
      </div>
      <div className="rectPrintBtnCont fx-jb space1">
        <button
          className="btnPrintRcpt"
          onClick={() => reactToPrintFn()}
          style={{ backgroundColor: "transparent", color: "#999" }}
        >
          <LocalPrintshopIcon style={{ fontSize: "3.2rem" }} />
        </button>
      </div>
      <button className="recieptPreBtnX" onClick={() => setOpenModal(false)}>
        <CloseIcon fontSize="large" />
      </button>
    </div>
  );
}
export function TerminalReprinting({ contentRef, soldPayload, setModalOpen }) {
  const reactToPrintFn = useReactToPrint({ contentRef });
  const companyData = useSelector(
    (state) => state.clientFunction?.companiesDB?.clientData,
  );
  const { inventory } = useSelector(
    (state) => state.terminalActions?.registerData,
  );

  const { userData } = useSelector(
    (state) => state.clientFunction?.companiesDB,
  );

  // Add before return

  const {
    customerId,
    customer_name,
    soldItems,
    totals,
    soldBy,
    payment,
    createdAt,
  } = soldPayload;

  console.log("soldPayload", soldPayload);

  const customerName = customer_name;
  const cart = soldItems || [];
  const subTotal = totals?.subtotal || 0;
  const discount = totals?.discount || 0;
  const tax = totals?.taxAmount || 0;
  const discountAmount = totals?.discountAmount ?? (discount?.type === "PERCENTAGE"
    ? Number(subTotal) * Number(discount?.amount || 0) / 100
    : Number(discount?.amount ?? discount) || 0);
  const receiptTotal = totals?.total ?? Math.round((Number(subTotal) - discountAmount + Number(tax) + Number.EPSILON) * 100) / 100;
  const paymentMethods = payment?.method || "";

  return (
    <div
      className="SalesRecieptWrap fx-cl space2"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="printAreaRecieptWrap">
        <div className="receiptTicket fx-cl " ref={contentRef}>
          <div className="rectContTop fx-cl ">
            <div
              className="componentCont fw200 fx-ac fx-jb"
              style={{ fontSize: "1rem" }}
            >
              <div className="fx-ac">
                <span className="fw400">{createdAt}</span>
              </div>
              <div className="fx-ac">
                <span className="cb">Receipt No: </span>
                <span className="fw600">{soldPayload?.saleId}</span>
              </div>
            </div>

            {/* TOP */}
            <div className="fx-cl">
              <h2>Sales Reciept</h2>
            </div>

            <div className="fx-ac fx-jc">
              <div
                className="componentCont fx-cl fx-ac fx-jc"
                style={{ textAlign: "center", width: "90%" }}
              >
                <span className="recptHead fw600 fs1">
                  {companyData?.businessProfile?.basicInfo?.businessName}
                </span>
                <span className="cb">
                  {inventory?.address
                    ? [
                        inventory.address.street,
                        inventory.address.area,
                        inventory.address.city,
                        inventory.address.state,
                        inventory.address.country,
                      ]
                        .filter(Boolean) // Removes empty string values
                        .join(", ")
                    : ""}
                </span>
                <span>
                  {companyData?.businessProfile?.location?.headOffice?.address}
                </span>
                {companyData?.businessProfile?.branding?.website && (
                  <span>{companyData?.businessProfile?.branding?.website}</span>
                )}
                <span className="cb fw600">
                  {companyData?.businessProfile?.basicInfo?.businessPhoneNo?.join(
                    " - ",
                  )}
                </span>
              </div>
            </div>

            <div
              className="componentCont fx-cl space2"
              style={{ borderTop: "1px dashed #333", paddingTop: ".8rem" }}
            >
              <div className="g g2 spacem">
                {/* BLUE BAR */}
                <div
                  className="ticketBlue fx-cl spacem"
                  style={{ borderRight: "1px dashed #333" }}
                >
                  <div className="fx-cl">
                    <span className=" cb">Processed by</span>
                    <strong>{soldBy?.name}</strong>
                  </div>

                  <div className="fx-cl">
                    <span className=" cb">Sold Item:</span>
                    <strong>
                      {cart?.reduce(
                        (total, item) =>
                          total + (Number(item?.soldQuantity) || 0),
                        0,
                      )}
                    </strong>
                  </div>
                </div>

                {/* RECEIPT DETAILS */}
                <div className="fx-cl spacem">
                  <div className="fx-cl">
                    <span className="cb ">Customer</span>
                    <strong>{customer_name}</strong>
                  </div>

                  <div className="fx-cl">
                    <span className="cb ">Customer ID</span>
                    <strong>{customerId}</strong>
                  </div>
                </div>
              </div>
            </div>

            {/* ITEMS */}
            <div className="fx-cl spacem">
              {soldItems && soldItems.length > 0 ? (
                <table className="componentCont fx-cl">
                  <thead className="fx-cl spacem">
                    <tr>
                      <th>Item</th>
                      <th>Qty</th>
                      <th>Price</th>
                      <th>Ext Price</th>
                    </tr>
                  </thead>

                  <tbody className="fx-cl spacem">
                    {soldItems.map((item, index) => (
                      <tr key={item.sku || index} className="itemRowTdCont">
                        <td>
                          <strong>{item.name}</strong>
                        </td>

                        <td>{item.soldQuantity}</td>

                        <td>
                          ₦
                          {Number(
                            item.pricing?.sellingPrice || 0,
                          ).toLocaleString()}
                        </td>

                        <td>
                          ₦
                          {(
                            Number(item.soldQuantity || 0) *
                            Number(item.pricing?.sellingPrice || 0)
                          ).toLocaleString()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p style={{ textAlign: "center" }}>Empty</p>
              )}
            </div>

            <div className="recptTotal componentCont fx-jb">
              <span>
                {companyData && (
                  <QRCodeCanvas
                    value={JSON.stringify({
                      salesId: soldPayload?.saleId || "",
                      customerName: customer_name || "",
                      customerId: customerId || "",
                      createdAt: createdAt || "",
                      soldBy: soldBy?.name || "",
                    })}
                    size={60}
                  />
                )}
              </span>

              <div className="fx-cl spacem">
                <div className="fx-jb space2">
                  <span>Subtotal: </span>
                  <strong>₦{Number(subTotal).toLocaleString()}</strong>
                </div>

                <div className="fx-jb">
                  <span>Discount</span>
                  <strong>
                    ₦{Number(discountAmount).toLocaleString()}
                  </strong>
                </div>

                <div className="fx-jb">
                  <span>Tax:</span>
                  <strong>₦{Number(tax || 0).toLocaleString()}</strong>
                </div>

                <div className="ticketTotal fx-jb spacem">
                  <span>
                    <strong>RECEIPT TOTAL:</strong>
                  </span>

                  <strong>
                    ₦
                    {Number(receiptTotal).toLocaleString()}
                  </strong>
                </div>

                <strong>Method: {payment?.method}</strong>
              </div>
            </div>
          </div>

          <div className="rectContBottom fx-cl fx-ac">
            <div className="componentCont fx-cl fx-ac fx-jc">
              <span>THANK YOU FOR YOUR PATRONAGE!</span>
              <span>OPENING HOURS</span>
              <span>We are open 7 days a week.</span>
              <span>7:00 AM – 11:00 PM</span>
              <span>We look forward to serving you again.</span>
            </div>

            <Barcode
              value={soldPayload?.saleId}
              format="CODE128"
              width={1.5}
              height={25}
              fontSize={12}
              displayValue={false}
            />
          </div>

          <span
            style={{
              textAlign: "center",
              fontFamily: "serif",
              fontStyle: "italic",
            }}
          >
            www.universeinventory.com
          </span>
        </div>
      </div>

      <div className="rectPrintBtnCont fx-jb space1">
        <button
          className="btnPrintRcpt"
          onClick={() => reactToPrintFn()}
          style={{ backgroundColor: "transparent", color: "#999" }}
        >
          <LocalPrintshopIcon style={{ fontSize: "3.2rem" }} />
        </button>
      </div>

      <button className="recieptPreBtnX" onClick={() => setModalOpen(false)}>
        <CloseIcon fontSize="large" />
      </button>
    </div>
  );
}
export function PrintSoldReciept({ contentRef, soldPayload, setModalOpen }) {
  const reactToPrintFn = useReactToPrint({ contentRef });
  const companyData = useSelector(
    (state) => state.clientFunction?.companiesDB?.clientData,
  );
  // Add before return

  const {
    customerId,
    customer_name,
    soldItems,
    totals,
    soldBy,
    payment,
    createdAt,
  } = soldPayload;

  console.log("soldPayload", soldPayload);

  const customerName = customer_name;
  const cart = soldItems || [];
  const subTotal = totals?.subtotal || 0;
  const discount = totals?.discount || 0;
  const tax = totals?.taxAmount || 0;
  const discountAmount = totals?.discountAmount ?? (discount?.type === "PERCENTAGE"
    ? Number(subTotal) * Number(discount?.amount || 0) / 100
    : Number(discount?.amount ?? discount) || 0);
  const receiptTotal = totals?.total ?? Math.round((Number(subTotal) - discountAmount + Number(tax) + Number.EPSILON) * 100) / 100;
  const paymentMethods = payment?.method || "";

  return (
    <div
      className="SalesRecieptWrap fx-cl space2"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="printAreaRecieptWrap">
        <div className="receiptTicket fx-cl " ref={contentRef}>
          <div className="rectContTop fx-cl ">
            <div
              className="componentCont fw200 fx-ac fx-jb"
              style={{ fontSize: "1rem" }}
            >
              <div className="fx-ac">
                <span className="fw400">{createdAt}</span>
              </div>
              <div className="fx-ac">
                <span className="cb">Receipt No: </span>
                <span className="fw600">{soldPayload?.saleId}</span>
              </div>
            </div>

            {/* TOP */}
            <div className="fx-cl">
              <h2>Sales Reciept</h2>
            </div>

            <div className="fx-ac fx-jc">
              <div
                className="componentCont fx-cl fx-ac fx-jc"
                style={{ textAlign: "center", width: "90%" }}
              >
                <span className="recptHead fw600 fs1">
                  {companyData?.businessProfile?.basicInfo?.businessName}
                </span>
                <span className="cb">
                  {companyData?.businessProfile?.address}
                </span>
                <span>
                  {companyData?.businessProfile?.location?.headOffice?.address}
                </span>
                {companyData?.businessProfile?.branding?.website && (
                  <span>{companyData?.businessProfile?.branding?.website}</span>
                )}
                <span className="cb fw600">
                  {companyData?.businessProfile?.basicInfo?.businessPhoneNo?.join(
                    " - ",
                  )}
                </span>
              </div>
            </div>

            <div
              className="componentCont fx-cl  space2"
              style={{ borderTop: "1px dashed #333", paddingTop: ".8rem" }}
            >
              <div className="g g2 spacem">
                {/* BLUE BAR */}
                <div
                  className="ticketBlue fx-cl spacem"
                  style={{ borderRight: "1px dashed #333" }}
                >
                  <div className="fx-cl">
                    <span className=" cb">Processed by</span>
                    <strong>{soldBy?.name}</strong>
                  </div>

                  <div className="fx-cl">
                    <span className=" cb">Sold Item:</span>
                    <strong>
                      {cart?.reduce(
                        (total, item) =>
                          total + (Number(item?.soldQuantity) || 0),
                        0,
                      )}
                    </strong>
                  </div>
                </div>

                {/* RECEIPT DETAILS */}
                <div className="fx-cl spacem">
                  <div className="fx-cl">
                    <span className="cb ">Customer</span>
                    <strong>{customer_name}</strong>
                  </div>

                  <div className="fx-cl">
                    <span className="cb ">Customer ID</span>
                    <strong>{customerId}</strong>
                  </div>
                </div>
              </div>
            </div>

            {/* ITEMS */}
            <div className="fx-cl spacem">
              {soldItems && soldItems.length > 0 ? (
                <table className="componentCont fx-cl">
                  <thead className="fx-cl spacem">
                    <tr>
                      <th>Item</th>
                      <th>Qty</th>
                      <th>Price</th>
                      <th>Ext Price</th>
                    </tr>
                  </thead>

                  <tbody className="fx-cl spacem">
                    {soldItems.map((item, index) => (
                      <tr key={item.sku || index} className="itemRowTdCont">
                        <td>
                          <strong>{item.name}</strong>
                        </td>

                        <td>{item.soldQuantity}</td>

                        <td>
                          ₦
                          {Number(
                            item.pricing?.sellingPrice || 0,
                          ).toLocaleString()}
                        </td>

                        <td>
                          ₦
                          {(
                            Number(item.soldQuantity || 0) *
                            Number(item.pricing?.sellingPrice || 0)
                          ).toLocaleString()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p style={{ textAlign: "center" }}>Empty</p>
              )}
            </div>

            <div className="recptTotal componentCont fx-jb">
              <span>
                {companyData && (
                  <QRCodeCanvas
                    value={JSON.stringify({
                      salesId: soldPayload?.saleId || "",
                      customerName: customer_name || "",
                      customerId: customerId || "",
                      createdAt: createdAt || "",
                      soldBy: soldBy?.name || "",
                    })}
                    size={60}
                  />
                )}
              </span>

              <div className="fx-cl spacem">
                <div className="fx-jb space2">
                  <span>Subtotal: </span>
                  <strong>₦{Number(subTotal).toLocaleString()}</strong>
                </div>

                <div className="fx-jb">
                  <span>Discount</span>
                  <strong>
                    ₦{Number(discountAmount).toLocaleString()}
                  </strong>
                </div>

                <div className="fx-jb">
                  <span>Tax:</span>
                  <strong>₦{Number(tax || 0).toLocaleString()}</strong>
                </div>

                <div className="ticketTotal fx-jb spacem">
                  <span>
                    <strong>RECEIPT TOTAL:</strong>
                  </span>

                  <strong>
                    ₦
                    {Number(receiptTotal).toLocaleString()}
                  </strong>
                </div>

                <strong>Method: {payment?.method}</strong>
              </div>
            </div>
          </div>

          <div className="rectContBottom fx-cl fx-ac">
            <div className="componentCont fx-cl fx-ac fx-jc">
              <span>THANK YOU FOR YOUR PATRONAGE!</span>
              <span>OPENING HOURS</span>
              <span>We are open 7 days a week.</span>
              <span>7:00 AM – 11:00 PM</span>
              <span>We look forward to serving you again.</span>
            </div>

            <Barcode
              value={soldPayload?.saleId}
              format="CODE128"
              width={1.5}
              height={25}
              fontSize={12}
              displayValue={false}
            />
          </div>

          <span
            style={{
              textAlign: "center",
              fontFamily: "serif",
              fontStyle: "italic",
            }}
          >
            www.universeinventory.com
          </span>
        </div>
      </div>

      <div className="rectPrintBtnCont fx-jb space1">
        <button
          className="btnPrintRcpt"
          onClick={() => reactToPrintFn()}
          style={{ backgroundColor: "transparent", color: "#999" }}
        >
          <LocalPrintshopIcon style={{ fontSize: "3.2rem" }} />
        </button>
      </div>

      <button className="recieptPreBtnX" onClick={() => setModalOpen(false)}>
        <CloseIcon fontSize="large" />
      </button>
    </div>
  );
}
